module.exports = __webpack_public_path__ + "img/angle_300.5643d781.jpg";